import React, { useEffect, useState } from "react";
import ReactApexChart from "react-apexcharts";
import { getmostpopularstops } from "../../../services/DashboardService";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { updateReportAction } from "../../../store/actions/AuthActions";
import { Spinner } from "react-bootstrap";
const MostPopularStopsChart = () => {
  const [data, setData] = useState([]);
  const [param, setParam] = useState({
    time_period: "week",
  });
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  useEffect(() => {
    setLoading(true);
    getmostpopularstops(param)
      .then((res) => {
        const formattedData = (res.data.data || []).map((item, index) => ({
          name: item.stop_name, // Extract the stop name
          value: item.employee_count, // Extract the employee count (which represents bus passes or activity)
          stopLabel:
            item.stop_name.length > 8
              ? item.stop_name.slice(0, 8) + "..."
              : item.stop_name, // Dynamically assign Stop 1, Stop 2, etc.
        }));
        setData(formattedData);
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [param]);
  const chartOptions = {
    chart: {
      type: "bar",
      height: 300,
      toolbar: { show: false },
    },
    plotOptions: {
      bar: {
        horizontal: false, // Vertical bars
        columnWidth: "40%",
        borderRadius: 4,
      },
    },
    dataLabels: { enabled: false },
    xaxis: {
      categories: data.map((item) => item.stopLabel), // Stop 1, Stop 2, etc.
      title: {
        // text: "Bus Stop",
        style: {
          color: "#333",
          fontSize: "14px",
          fontWeight: 600,
        },
      },
      labels: {
        show: true,
        rotate: -45,
        style: {
          fontSize: "12px",
          fontWeight: 500,
          colors: "#333",
        },
        trim: false,
        maxHeight: 100,
      },
      axisBorder: {
        show: true,
        color: "#ccc",
      },
      axisTicks: {
        show: true,
        color: "#ccc",
      },
    },

    yaxis: {
      labels: {
        style: { fontSize: "13px" },
      },
      title: {
        // text: "Passes",
        style: {
          color: "#333",
          fontSize: "14px",
          fontWeight: 600,
        },
      },
    },
    grid: {
      show: true,
      borderColor: "rgba(166, 138, 100, 0.3)", // Lighter brown with transparency for subtle effect
      strokeDashArray: 4, // Keep dashed grid lines
      position: "back",
      xaxis: {
        lines: {
          show: false, // Keep x-axis grid lines hidden
        },
      },
      yaxis: {
        lines: {
          show: true,
        },
      },
    },
    colors: ["#482807"],
    tooltip: {
      enabled: true,
      y: { formatter: (val) => `${val} passes` },
      custom: ({ seriesIndex, dataPointIndex, w }) => {
        const stopName = data[dataPointIndex].name; // Get the stop name from the data
        const count = w.config.series[seriesIndex].data[dataPointIndex]; // Get the bus count
        return `<div style="z-index:2000;background-color:#482807; padding: 10px; border-radius: 5px; color: white;">
                  <strong>${stopName}</strong><br />
                  Passes: <span style="font-size: 16px; font-weight: bold;">${count}</span>
                </div>`;
      },
    },
  };
  const chartSeries = [
    {
      name: "Active Passes",
      data: data.map((item) => item.value),
    },
  ];
  const handlepopularstop = () => {
    dispatch(
      updateReportAction({
        label: "Popular Bus Report",
        value: "PopularBusReport",
      })
    );
    navigate("/report");
  };
  return (
    <>
      <div className="card border rounded-3">
        <div className="p-2 d-flex justify-content-between">
          <span className="text-primary" style={{ fontWeight: "500" }}>
            Popular Stops
          </span>
          <div className="btn-group align-self-start">
            <button
              className={`btn btn-sm btn-outline-primary ${
                param.time_period === "week" ? "active" : ""
              }`}
              onClick={() => setParam({ time_period: "week" })}
            >
              W
            </button>
            <button
              className={`btn btn-sm btn-outline-primary ${
                param.time_period === "month" ? "active" : ""
              }`}
              onClick={() => setParam({ time_period: "month" })}
            >
              M
            </button>
            <button
              className={`btn btn-sm btn-outline-primary ${
                param.time_period === "year" ? "active" : ""
              }`}
              onClick={() => setParam({ time_period: "year" })}
            >
              Y
            </button>
          </div>
        </div>
        <div className="card-body">
          {loading ? (
            <div className="text-center my-3">
              <Spinner animation="border" size="sm" />
            </div>
          ) : data?.length == 0 ? (
            <div className="text-center my-2">No Data Found</div>
          ) : (
            <>
              <ReactApexChart
                key={
                  chartSeries.join(",") +
                  (chartOptions?.labels?.join(",") || "")
                }
                options={chartOptions}
                series={chartSeries}
                type="bar"
                height={240}
              />
              <div
                className="text-center pt-1"
                style={{ fontWeight: "500", fontSize: "0.9rem" }}
              >
                <span
                  className="text-primary cursor-pointer"
                  onClick={handlepopularstop}
                >
                  View Reports
                </span>
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default MostPopularStopsChart;
